import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { GetJson } from '../helpers/fetchReact';
import { REST_API } from '../constants';
import { STATE_STATUS } from '../constants';

const initialState = {
  systemNotifications: [],
  status: STATE_STATUS.IDLE,
  error: null,
};

export const selectSystemNotifications = (state) => state.systemNotifications.systemNotifications;

export const fetchSystemNotifications = createAsyncThunk('systemNotifications/fetchSystemNotifications', async () => {
  const url = REST_API.SYSTEM_NOTIFICATIONS;
  return GetJson(url).then((response) => response.json());
});

export const systemNotificationsSlice = createSlice({
  name: 'systemNotifications',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchSystemNotifications.pending]: (state) => {
      state.status = STATE_STATUS.LOADING;
    },
    [fetchSystemNotifications.fulfilled]: (state, action) => {
      state.status = STATE_STATUS.SUCCESS;
      state.systemNotifications = action.payload;
    },
    [fetchSystemNotifications.rejected]: (state, action) => {
      state.status = STATE_STATUS.FAILED;
      state.error = action.error.message;
    },
  },
});
